import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Contexto } from "../../Context/Contexto";
import { useParams,useLocation } from "react-router-dom";
import { MensajeCont } from "../../Context/MensajeContext";

export default function PublicRouter({children})
{
    const UrlBase="";
    const {Cli}=useContext(Contexto)
    const {SetRedireccionamiento}=useContext(MensajeCont)
    let { id } = useParams();

    const location = useLocation();
    if(location.hash!="")
    {
        SetRedireccionamiento(location.hash)
    }

    if(id!=null && id!=undefined)
    {
        return children;
    }else
    {
        if(Cli==undefined || Cli==null)
        {
            return children;
        }else
        {
            
            if(Cli.rut!=0)
            {
                
                return <Navigate to="/home"></Navigate>;
            }else
            {
                if(Cli.lCasilla[0].ecode!=undefined)
                {
                    
                    if(Cli.lCasilla[0].ecode!="")
                    {
                        return <Navigate to="/home"></Navigate>;
                    }else
                    {
                        return children;
                    }
                }
                else
                {
                    
                    return children;
                } 
            }
               
        }
    }

    
    
    

    
}